"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlankSteps = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
exports.BlankSteps = react_1.default.forwardRef(function BlankSteps(_a, ref) {
    var _b = _a.steps, steps = _b === void 0 ? [] : _b, className = _a.className, props = tslib_1.__rest(_a, ["steps", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-blank-page-v2__step", className) }, props), steps.map(function (step, index) { return (react_1.default.createElement("div", { className: "item", key: index },
        react_1.default.createElement("i", { className: "num" }, index + 1),
        step)); })));
});
exports.BlankSteps.displayName = "BlankSteps";
//# sourceMappingURL=BlankSteps.js.map